// extracted by mini-css-extract-plugin
export var component = "AccountChoosingForm-module--component--+xi5O";
export var form = "AccountChoosingForm-module--form---Mc+1";
export var loginBtn = "AccountChoosingForm-module--loginBtn--q0BHa";
export var wrapper = "AccountChoosingForm-module--wrapper--sP6tm";